import { Box, Typography } from '@mui/material'
import React from 'react'
import { useSize } from '../../../hooks/useSize'
import styles from '../common.module.scss'

const Compliance: React.FC = () => {
  const { matchTabletSize } = useSize()

  return (
    <>
      <Box maxWidth="md" className={`${styles.header} ${matchTabletSize ? styles.header__sp : styles.header__pc}`}>
        <Typography lineHeight={0.9} fontSize={matchTabletSize ? '26px' : '43px'} fontWeight="bold">
          コンプライアンス
        </Typography>
        <Typography fontSize={matchTabletSize ? '12px' : '20px'}>Compliance</Typography>
      </Box>
      <Box maxWidth="md" m="auto">
        <article className={matchTabletSize ? styles.container__sp : styles.container__pc}>
          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              通報窓口
            </Typography>
            <Typography variant="body1">
              当社では、公益通報者保護法その他関係法令の主旨に則り、社内通報制度規程を定めております。
              当社もしくは当社社員による、法令違反やハラスメントなど、コンプライアンスに反する行為、
              もしくはおそれのある行為を発見された際は、当社までご連絡賜りますようお願いいたします。
            </Typography>
            <Typography variant="body1" className={styles.note}>
              ※AGキャピタルをご利用中のお客様のお取引内容等に関するお問い合わせは、ホームページの「お問い合わせ」から、各種お問い合わせ先をご確認ください。
            </Typography>
          </Box>

          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              通報・相談対象者
            </Typography>
            <Typography variant="body1">
              当社とお取引関係にある法人、企業、団体等にお勤めの方（フリーランスの方含む）
            </Typography>
          </Box>

          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              受付内容
            </Typography>
            <Typography variant="body1">
              通報にあたっては、以下内容をご連絡ください。
              <br />
              ご連絡内容：通報いただける方の氏名、連絡先（TEL番号、メールアドレス等）、企業名、事案の内容、調査結果等の連絡要否
              <br />
            </Typography>
            <Typography variant="body1" className={styles.note}>
              ※匿名でも受付させていただきますが、調査の範囲が限定的となったり、調査結果等のご連絡ができない場合がございますのであらかじめご了承ください。
            </Typography>
          </Box>

          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              受付方法
            </Typography>
            <Typography variant="body1">
              eメール、郵送にて受付させていただきますので、以下の宛先へご連絡ください。
              <br />
              eメール：compliance@aiful.co.jp
              <br />
              郵送：〒600-8420 京都市下京区烏丸通五条上る高砂町381-1　アイフル株式会社　リスク統括部
            </Typography>
          </Box>

          <Box className={styles.content}>
            <Typography variant="subtitle2" pb={1.5}>
              個人情報の取り扱い
            </Typography>
            <Typography variant="body1">
              相談・通報された方の個人情報および相談・通報内容は、調査および対処にのみ利用するものとし、調査関係者以外には開示いたしません。
            </Typography>
            <Typography variant="body1" className={styles.note}>
              ※個人情報の管理業務に係る第三者への業務委託について
              <br />
              当社では、当社に代わり通報を受け付けるため、グループ会社であるアイフル株式会社へ受付業務を委託しております。
            </Typography>
          </Box>
        </article>
      </Box>
    </>
  )
}

export default Compliance
